import {
    useQueryParam,
    NumberParam,
    StringParam,
    withDefault,
} from 'use-query-params';
import {RushTypes} from '@types';

export const useRushQueryParams = () => {
    const [tab, setTab] = useQueryParam(
        'tab',
        withDefault(StringParam, 'global')
    );
    const [rushType, setRushType] = useQueryParam(
        'rush_type',
        withDefault(NumberParam, RushTypes.TYPE_3_MINUTES)
    );
    const [filter, setFilter] = useQueryParam(
        'filter',
        withDefault(StringParam, 'all_time')
    );
    const [sort, setSort] = useQueryParam(
        'sort',
        withDefault(StringParam, 'score')
    );

    return {
        rushType,
        filter,
        sort,
        tab,
        setRushType,
        setFilter,
        setSort,
        setTab,
    };
};
